<template>
  <v-layout>
    <v-flex>
      <v-tabs v-model="active">
        <v-tab><h6>Configuration</h6></v-tab>
        <v-tab><h6>Log Levels</h6></v-tab>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <h3 class="headline mb-0 admin-header">Configuration</h3>
              <v-btn text icon color="grey lighten-1" @click="refreshList"><v-icon>fas fa-sync</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-1" @click="showExtraConfigs">Edit Extra Configs</v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-1" @click="showAllowedTypes">Edit Allowed Types</v-btn>
              <v-dialog v-model="showExtraConfigsDialog" max-width="900px">
              <v-card>
                <v-card-title>
                  <span class="headline">Extra Configs</span>
                </v-card-title>
                <v-card-text>
                  <!-- <v-container grid-list-md> -->
                    <nv-pair 
                      v-if="showExtraConfigsDialog"
                      :input="extraConfigsString" 
                      @cancel="showExtraConfigsDialog=false"
                      @save="saveExtraConfigs"></nv-pair>
                    <!-- <v-layout wrap>
                      <v-flex xs12>
                        <v-textarea label="Extra Configs" v-model="extraConfigsString"></v-textarea>
                      </v-flex>
                    </v-layout> -->
                    <!-- </v-container> -->
                </v-card-text>

                <!-- <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="blue darken-1" @click.native="showExtraConfigsDialog=false">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click.native="saveExtraConfigs">Save</v-btn>
                </v-card-actions> -->
              </v-card>
            </v-dialog>
            <v-dialog v-model="showAllowedTypesDialog" max-width="900px">
              <v-card>
                <v-card-title>
                  <span class="headline">Allowed Types</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-select :items="allTypeCodes" v-model="allowedTypes" label="Types" multiple></v-select>
                      </v-flex>
                    </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="blue darken-1" @click.native="showAllowedTypesDialog=false">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click.native="saveAllowedTypes">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="fal fa-search"
                placeholder="Search"
                single-line
                hide-details
                clearable>
              </v-text-field>
            </v-card-title>
            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">Configuration</span>
                </v-card-title>
                <v-card-text>
                  <v-form v-model="valid" @submit.prevent>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 v-if="!editedItem.type || editedItem.type === 'text'">
                        <v-text-field v-model="editedItem.value" :label="editedItem.parameter.name"></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="editedItem.type === 'numeric'">
                        <v-text-field v-model="editedItem.value" :label="editedItem.parameter.name" :rules="[rules.numeric]"></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="editedItem.type === 'boolean'">
                        <v-checkbox v-model="editedItemBooleanValue" :label="editedItem.parameter.name"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 v-if="editedItem.type === 'list'">
                        <v-select :items="editedItem.options.split(',')" v-model="editedItem.value" :label="editedItem.parameter.name"></v-select>
                      </v-flex>
                    </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="blue darken-1" @click.native="close">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click.native="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="filteredConfigs()"
              :search="search"
              :loading="loading"
              :options.sync="pagination"
              item-key="parameter.key"
              class="elevation-1"
            >
              <template v-slot:item.actions="{item}">
                <td class="actions">
                  <v-btn text icon @click="editItem(item)" style="height: 0px; width: 0px; padding-right:2px; padding-bottom:20px;">
                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                  </v-btn>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" type="warning">
                  Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-layout wrap align-center ml-1>
              <v-flex xs12><p></p><h3 class="headline mb-0">Server Log Levels</h3> </v-flex>
              <v-flex xs3 pa-2>
                <v-checkbox @change="changed=true;"
                label="Correlated (Requires collector v4.5 or newer)" v-model="objCorrelated.value" hint="If checked, server logs will follow the Collector Log Levels scheme below" persistent-hint></v-checkbox>
              </v-flex>
              <v-flex xs3 pa-2 v-if="!objCorrelated.value">
                <v-select @change="changed=true;"
                label="Logging Level" v-model="objLogLevel.value" hint="Server logs will be at this selected level" persistent-hint
                :items="['Error', 'Warn', 'Info', 'Debug', 'Trace']"></v-select>
              </v-flex>
              <v-flex xs3 pa-2 v-if="!objCorrelated.value && objLogLevel.value == 'Trace'">
                <v-alert :value="true" type="warning">Please change the level back to Debug after your troubleshooting.</v-alert>
              </v-flex>
              <v-flex xs3 pa-2 v-if="objCorrelated.value">
                <v-alert :value="true" type="warning">If you have any Trace enabled, please set the level back to Debug after your troubleshooting.</v-alert>
              </v-flex>
              <v-flex xs3 pa-2 v-if="changed">
                <v-btn text @click="applyLogLevel" color="orange">Apply Log Level Changes</v-btn>
              </v-flex>
              <v-flex xs12 v-if="objCorrelated.value">
              <log-levels-subpanel></log-levels-subpanel>
              </v-flex>
            </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CollectorLogLevelsSubPanel from '../Logs/CollectorLogLevelsSubPanel.vue'
import NVPair from '../Common/NVPair.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    'log-levels-subpanel': CollectorLogLevelsSubPanel,
    'nv-pair': NVPair
  },
  data(){
    return {
      headers: [
        {text: 'Name', align: 'left', sortable: true, value: 'parameter.name'},
        {text: 'Key', align: 'left', sortable: true, value: 'parameter.key'},
        {text: 'Value', align: 'left', sortable: true, value: 'value'},
        {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
      ],
      search: '',
      active: null,
      dialog: false,
      editedItem: {
        id: -1,
        extraConfig: false,
        parameter: {},
        parent: {},
        value: ''
      },
      defaultItem: {
        id: -1,
        extraConfig: false,
        parameter: {},
        parent: {},
        value: ''
      },
      editedId: -1,
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      rules: {
          numeric: value => !value || !isNaN(value) || 'Invalid format'
      },
      valid: false,
      objLogLevel: {value: null},
      objCorrelated: {value: false},
      changed: false,
      showExtraConfigsDialog: false,
      showAllowedTypesDialog: false,      
      extraConfigsString: null,
      allowedTypes: []
    }
  },
  computed: {
    ...mapGetters('user', {
      orgContext: 'getOrgContext',
      appConfigs: 'getAppConfigs'
    }),
    ...mapGetters('systems', {
      allTypeCodes: 'allTypeCodes'
    }),
    editedItemBooleanValue: {
      get() {
        return this.editedItem.value === "true" || this.editedItem.value === true ? true : false
      },
      set(value) {
        this.editedItem.value = value.toString()
      }
    }
  },
  watch: {
    orgContext: async function(val) {

      await this.refreshList()
    }
  },
  async created () {
    await this.refreshList()
  },
  methods:{
    filteredConfigs() {
      if (!this.appConfigs) {
        return []
      }
      return _.reject(this.appConfigs, (cfg) => {return cfg.parameter.key.startsWith('van.logging')})
    },
    async editItem (item) {
        this.editedId = item.id
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },
    async refreshList () {
      this.loading = true
      await this.$store.dispatch('user/getAppConfigs')
      this.$store.dispatch('systems/getAllTypeCodes')
      this.objLogLevel = _.find(this.appConfigs, (cfg) => { return cfg.parameter.key === 'van.logging.level'}) || {value:null}
      this.objCorrelated = _.find(this.appConfigs, (cfg) => { return cfg.parameter.key === 'van.logging.correlated'}) || {value:false}
      this.objCorrelated.value = this.objCorrelated.value === "true" || this.objCorrelated.value === true ? true : false
      this.loading = false
    },
    close() {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedId = -1
        }, 300)
    },
    async save () {
      if (this.editedId > -1) {
        await this.$store.dispatch("user/updateAppConfig", this.editedItem)
      }
      this.close()

      this.loading = true
      await this.$store.dispatch('user/getAppConfigs')
      this.loading = false
    },
    async applyLogLevel () {

      if (!this.objCorrelated.value) {

        // let traceReset = {
        //     "id": 0,
        //     "olv": 0,
        //     "parameter": {
        //         "id": 0,
        //         "key": "van.logging.trace.reset",
        //         "name": "Trace Logging Reset",
        //         "description": null
        //     },
        //     "parent": null,
        //     "value": this.objLogLevel.value === 'Trace' ? moment().add(1, 'hours').valueOf() : null,
        //     "type": "text",
        //     "options": "",
        //     "extraConfig": true
        // }

        await this.$store.dispatch("user/updateAppConfig", this.objLogLevel)
       // await this.$store.dispatch("user/updateAppConfig", traceReset)
      }

      let correlated = {
        "id": 0,
        "olv": 0,
        "parameter": {
            "id": 0,
            "key": "van.logging.correlated",
            "name": "Correlated Logging",
            "description": null
        },
        "parent": null,
        "value": this.objCorrelated.value,
        "type": "boolean",
        "options": "",
        "extraConfig": true
      }

      await this.$store.dispatch("user/updateAppConfig", correlated)

      await this.refreshList()

      this.changed = false;
    },
    async showExtraConfigs () {
      this.extraConfigsString = await this.$store.dispatch("systems/getExtraConfigValues")
      this.showExtraConfigsDialog = true
    },
    async saveExtraConfigs (val) {
      this.extraConfigsString = val
      await this.$store.dispatch("systems/saveExtraConfigValuesStr", this.extraConfigsString)
      this.showExtraConfigsDialog = false
      await this.refreshList()
    },
    async showAllowedTypes () {
      const allowedTypesString = await this.$store.dispatch("systems/getAllowedTypes")
      this.allowedTypes = _.split(allowedTypesString, ',')
      this.showAllowedTypesDialog = true
    },
    async saveAllowedTypes () {
      await this.$store.dispatch("systems/saveAllowedTypes", _.join(this.allowedTypes, ','))
      this.showAllowedTypesDialog = false
      await this.refreshList()
    }
  }
}
</script>
